/**
 * OLAYLARIN OKUNABILIR KARSILIGI — F-LOG-01
 *
 * ================================================================
 * NEDEN VAR
 * ================================================================
 * Denetim kaydinin tipi makine icin yazilmis: `IMPERSONATION_STARTED`,
 * `TRUSTED_DEVICE_USED`, `ACCESS_DENIED`. Log ekranina bakan kisi
 * cogu zaman gelistirici degil — "bu isi kim yapti, ne yapti" sorusunu
 * soran bir yonetici. Teknik kod tek basina o soruyu cevaplamiyor.
 *
 * Teknik kod EKRANDAN KALDIRILMIYOR: bir olayin izini surmek, filtre
 * kutusuna tam tipi yazmak ya da bir hatayi bildirmek gerektiginde
 * Turkce cumle degil, tam tip aranir. Ikisi birlikte gosteriliyor.
 *
 * ================================================================
 * NEDEN CUMLELER FIIL, ISIM DEGIL
 * ================================================================
 * Satirin yaninda zaten AKTOR yaziyor. "Görünüm başlangıcı" gibi bir
 * isim tamlamasi aktorle yan yana okunmuyor; "Başka bir kullanıcının
 * görünümüne geçildi" okunuyor. Metinler o yuzden edilgen fiil
 * cumlesi: "<aktor> · <cumle>" bir cumle gibi okunsun diye.
 *
 * ================================================================
 * NEDEN BURADA, `events.ts` ICINDE DEGIL
 * ================================================================
 * `apps/api/src/modules/audit/events.ts` katalogun kendisi ve
 * `@koclukpanel/db` uzerinden Prisma'ya bagli. Panel oraya bagimli
 * olamaz. Metinler bu yuzden paylasilan sozlesme paketinde duruyor;
 * ileride ogrenci uygulamasi ya da mobil de ayni cumleleri kullanir.
 *
 * BEDELI: katalog iki dosyada yasiyor ve ikisi ayrisabilir. Bunu
 * `olay-metni.test.ts` icindeki bekci olcuyor — hem eksik anahtari
 * hem de olu kaydi (sozlukte var, katalogda yok) yakaliyor. Yeni bir
 * olay tipi ekleyip buraya cumle yazmayi unutmak testi DUSURUR.
 */

const OLAY_METNI = {
  // --- IDENTITY — kimlik -------------------------------------------
  LOGIN_SUCCESS: "Sisteme giriş yapıldı",
  LOGIN_FAILED: "Giriş denemesi başarısız oldu",
  LOGOUT: "Sistemden çıkış yapıldı",
  PASSWORD_CHANGED: "Şifre değiştirildi",
  PASSWORD_RESET_REQUESTED: "Şifre sıfırlama bağlantısı istendi",
  TWO_FACTOR_ENABLED: "İki adımlı doğrulama açıldı",
  TWO_FACTOR_DISABLED: "İki adımlı doğrulama kapatıldı",
  TWO_FACTOR_VERIFIED: "İki adımlı doğrulama kodu doğrulandı",
  TWO_FACTOR_FAILED: "İki adımlı doğrulama kodu yanlış girildi",
  // G-AUT-03 — sifirlamayi kisinin KENDISI yapamaz; cumle bu yuzden
  // "kendi 2FA'si sifirlandi" degil, "baskasininki".
  TWO_FACTOR_RESET: "Başkasının iki adımlı doğrulaması sıfırlandı",
  BACKUP_CODE_USED: "Yedek kod kullanılarak giriş yapıldı",
  BACKUP_CODES_REGENERATED: "Yedek kodlar yenilendi",
  ACCOUNT_LOCKED: "Hesap kilitlendi",
  ACCOUNT_UNLOCKED: "Hesap kilidi açıldı",
  INVITE_SENT: "Kullanıcı daveti gönderildi",
  INVITE_FAILED: "Kullanıcı davet postası gönderilemedi",
  INVITE_ACCEPTED: "Davet kabul edildi, hesap kuruldu",
  EMAIL_VERIFIED: "E-posta adresi doğrulandı",

  // --- SESSION — oturum --------------------------------------------
  SESSION_STARTED: "Oturum açıldı",
  SESSION_ENDED: "Oturum kapatıldı",
  SESSION_EXPIRED: "Oturum süresi doldu",
  SESSION_REVOKED: "Oturum uzaktan sonlandırıldı",
  SUDO_GRANTED: "Hassas işlem için kimlik yeniden doğrulandı",
  SUDO_FAILED: "Hassas işlem doğrulaması başarısız oldu",
  NEW_DEVICE: "Tanınmayan bir cihazdan giriş yapıldı",
  NEW_COUNTRY: "Alışılmadık bir ülkeden giriş yapıldı",
  ACTIVITY_SEGMENT: "Kesintisiz kullanım aralığı kaydedildi",
  SCREEN_VISIT: "Bir ekran görüntülendi",

  // --- DATA_CHANGE — veri degisikligi ------------------------------
  CREATED: "Yeni kayıt oluşturuldu",
  UPDATED: "Kayıt güncellendi",
  ARCHIVED: "Kayıt arşive kaldırıldı",
  RESTORED: "Kayıt arşivden geri alındı",
  DELETED: "Kayıt kalıcı olarak silindi",
  BULK_UPDATED: "Birden çok kayıt toplu güncellendi",
  // F-PPL-13 — ayri tip olmasinin sebebi "kim kaldirdi" sorusunun
  // siradan guncellemeler arasinda aranmamasi; cumle de o soruyu
  // cevapliyor: baskasinin fotografi.
  AVATAR_REMOVED: "Bir kullanıcının profil fotoğrafı kaldırıldı",

  // --- DATA_READ — okuma -------------------------------------------
  RECORD_VIEWED: "Bir kayıt görüntülendi",
  LIST_VIEWED: "Kayıt listesi görüntülendi",
  PROTECTED_NOTE_READ: "Korumalı PDR notu okundu",
  FILE_DOWNLOADED: "Dosya indirildi",
  REPORT_VIEWED: "Rapor görüntülendi",

  // --- AUTHORIZATION — yetki ---------------------------------------
  ROLE_CREATED: "Yeni rol oluşturuldu",
  ROLE_UPDATED: "Rolün izinleri değiştirildi",
  ROLE_DELETED: "Rol silindi",
  ROLE_ASSIGNED: "Kullanıcıya rol verildi",
  ROLE_REVOKED: "Kullanıcıdan rol geri alındı",
  PERMISSION_GRANTED: "Kişiye özel ek izin tanındı",
  PERMISSION_DENIED_OVERRIDE: "Kişiye özel izin kısıtı kondu",
  OVERRIDE_EXPIRED: "Süreli izin istisnası kendiliğinden bitti",
  BREAK_GLASS_OPENED: "Acil durum erişimi (cam kırma) açıldı",
  BREAK_GLASS_CLOSED: "Acil durum erişimi kapatıldı",
  BREAK_GLASS_REVOKED: "Acil durum erişimi geri alındı",
  IMPERSONATION_STARTED: "Başka bir kullanıcının görünümüne geçildi",
  IMPERSONATION_ENDED: "Kullanıcı görünümünden çıkıldı",
  // F-AUTH-07 — `ACCESS_DENIED`ten farki: yetki EKSIK degil, engel
  // gorunum kipinin kendisi. Cumleler de birbirine benzemiyor ki
  // ekranda ayirt edilebilsin.
  IMPERSONATION_BLOCKED: "Kullanıcı görünümünde kritik işlem engellendi",
  ACCESS_DENIED: "Yetkisiz erişim denemesi reddedildi",

  POINTS_MANUAL_GRANTED: "Öğrenciye elle puan verildi",
  POINTS_ADJUSTED: "Puan gerekçeyle düzeltildi",
  POINT_RULES_VERSIONED: "Yeni puan kuralı sürümü açıldı",
  STORE_PRODUCT_CREATED: "Ödül mağazasına ürün eklendi",
  STORE_PRODUCT_UPDATED: "Mağaza ürünü düzenlendi",
  STORE_PRODUCT_ARCHIVED: "Mağaza ürünü arşivlendi",
  STORE_PRICE_CHANGED: "Mağaza ürününün puan fiyatı değişti",
  STORE_ADDRESS_PROVIDED: "Ödül siparişi için teslim adresi verildi",
  STORE_ORDER_CANCELLED: "Ödül siparişi iptal edildi, puan iade edildi",
  STORE_ORDER_PAPER_APPROVED: "Ödül siparişi kâğıt veli onayıyla onaylandı",
  // F-GAM-19 (7b) — tek tek çevirmeler denetime yazılmaz; yalnız yönetim işlemleri.
  WHEEL_TABLE_VERSIONED: "Çarkın yeni oran tablosu yayımlandı",
  WHEEL_TOGGLED: "Çark açıldı ya da kapatıldı",
  // F-EXM-09 — tek olay bir sınav türünün tam kümesi (ekle/değiştir/arşivle birlikte).
  TARGET_NET_SET: "Öğrencinin ders bazlı hedef netleri güncellendi",
  // F-EXM-14…24 (TASLAK 01.11.2026) — deneme havuzu ve karne; net değerleri yüke girmez.
  EXAM_POOL_CREATED: "Ortak havuza yeni deneme girildi",
  EXAM_OUTCOMES_UPLOADED: "Denemenin kazanım listesi yüklendi",
  EXAM_ANSWERS_UNLOCKED: "Öğrencinin deneme cevap kilidi düzeltme için açıldı",
  EXAM_ENTRY_REOPENED: "Denemeyi kaçıran öğrenciye cevap girişi yeniden açıldı",
  EXAM_QUESTION_CANCELLED: "Denemede soru iptal edildi",
  EXAM_KEY_CORRECTED: "Sonucu olan denemenin cevap anahtarı düzeltildi",
  EXAM_RESULTS_RECALCULATED: "Deneme sonuçları ve sıralama yeniden hesaplandı",
  EXAM_RANKING_VISIBILITY_CHANGED: "Öğrenci ve veliye kurum içi sıralama gösterimi değiştirildi",
  // F-MNT-19 (TASLAK 01.11.2026) — Mentörüm; duygu, yanıt ve içerik metni yüke girmez.
  MENTORUM_ACCESS_GRANTED: "Öğrenciye Mentörüm erişimi verildi",
  MENTORUM_ACCESS_EXTENDED: "Öğrencinin Mentörüm erişimi uzatıldı",
  MENTORUM_ACCESS_ENDED: "Öğrencinin Mentörüm erişimi sonlandırıldı",
  MENTORUM_CONSENT_GIVEN: "Mentörüm onayı verildi",
  MENTORUM_CONSENT_WITHDRAWN: "Mentörüm onayı geri çekildi",
  MENTORUM_CONTENT_CHANGED: "Mentörüm içeriği değiştirildi",
  MENTORUM_CONTENT_PUBLISHED: "Mentörüm konusu öğrencilere açıldı",
  MENTORUM_RISK_RULES_CHANGED: "Mentörüm risk listesi ya da riskli seçenek değiştirildi",

  // --- WORKFLOW — is akisi -----------------------------------------
  SCHEDULE_PUBLISHED: "Haftalık program yayımlandı",
  SCHEDULE_SUBMITTED: "Haftalık program onaya gönderildi",
  APPROVED: "Onay verildi",
  REJECTED: "Onay reddedildi",
  REPORT_GENERATED: "Rapor oluşturuldu",
  REPORT_SENT: "Rapor gönderildi",
  SURVEY_SENT: "Anket gönderildi",
  REQUEST_OPENED: "Talep açıldı",
  REQUEST_CLOSED: "Talep kapatıldı",
  COACH_TRANSFERRED: "Öğrenci başka bir koça devredildi",
  SESSION_LOGGED: "Görüşme kaydı yazıldı",
  LEAD_STATUS_CHANGED: "Aday başka bir huni basamağına taşındı",
  LEAD_ENROLLED: "Aday öğrenciye dönüştürüldü",
  INTRO_REPORT_SUBMITTED: "Tanışma görüşmesi raporu yazıldı",
  INTRO_REPORT_APPROVED: "Tanışma görüşmesi raporu onaylandı",
  INTRO_NO_SHOW: "Aday tanışma görüşmesine katılmadı",
  TASK_ASSIGNED: "Personele görev atandı",
  TASK_UPDATED: "Görev güncellendi",
  TASK_COMPLETED: "Görev tamamlandı",

  CAMPAIGN_POINTS_CLAIMED: "Öğrenci teşekkür puanını aldı (Instagram)",
  STORE_ORDER_PLACED: "Öğrenci puanla ödül talep etti",
  STORE_ORDER_PARENT_APPROVED: "Veli ödül talebini onayladı",
  STORE_ORDER_PARENT_REJECTED: "Veli ödül talebini reddetti",
  PARENT_LINK_SENT: "Veli bağı doğrulama bağlantısı gönderildi",
  PARENT_LINK_VERIFIED: "Veli bağı doğrulandı",
  PARENT_LINK_RESET: "Veli bağı doğrulaması sıfırlandı",
  PARENT_LINK_FAILED: "Veli bağı doğrulaması başarısız",
  MENTORUM_COACHING_STARTED: "Koçsuz öğrenci koçluğa geçirildi",
  STORE_ORDER_STATUS_CHANGED: "Ödül siparişinin kargo durumu değişti",
  STORE_ORDER_EXPIRED: "Ödül talebi süresinde onaylanmadığı için iptal edildi",
  STORE_ORDER_REMINDED: "Ödül talebi için hatırlatma gönderildi",
  // F-GAM-18 (7b) — öğrenci davet kodu; kullanıcı hesabı davetiyle (INVITE_SENT) karışmaz.
  INVITE_CODE_CREATED: "Öğrenci davet kodu oluşturdu",
  INVITE_CODE_LINKED: "Adaya davet kodu girildi",
  INVITE_POINTS_AWARDED: "Davet puanı yazıldı",
  INVITE_REWARD_CLOSED: "Davet ödülü düştü (ödül yazılmadan kapandı)",
  // F-MNT-14 — uyarı yalnız yönetime; eşleşen kelime ve yanıt metni yüke girmez.
  MENTORUM_RISK_ALERT_CREATED: "Mentörüm risk uyarısı oluştu",
  MENTORUM_RISK_ALERT_HANDLED: "Mentörüm risk uyarısı ele alındı olarak işaretlendi",

  // --- COMMUNICATION — iletisim ------------------------------------
  NOTIFICATION_QUEUED: "Bildirim gönderim kuyruğuna alındı",
  NOTIFICATION_SENT: "Bildirim gönderildi",
  NOTIFICATION_DELIVERED: "Bildirim alıcıya ulaştı",
  NOTIFICATION_READ: "Bildirim okundu",
  NOTIFICATION_FAILED: "Bildirim gönderilemedi",
  CONSENT_REMINDER_SENT: "Eksik muvafakat için hatırlatma gönderildi",
  CONSENT_PAPER_RECORDED: "Kâğıt (ıslak imzalı) veli onayı kaydedildi",

  // --- FINANCE — finans --------------------------------------------
  PAYMENT_RECEIVED: "Ödeme alındı",
  PAYMENT_FAILED: "Ödeme alınamadı",
  PLAN_CHANGED: "Ödeme planı değiştirildi",
  REFUND_ISSUED: "İade yapıldı",
  INVOICE_ISSUED: "Fatura kesildi",
  INVOICE_FAILED: "Fatura kesilemedi",

  // --- EXPORT — disa aktarma ---------------------------------------
  EXPORT_STARTED: "Dışa aktarma başlatıldı",
  EXPORT_COMPLETED: "Dışa aktarma tamamlandı",
  BULK_DOWNLOAD: "Çok sayıda dosya toplu indirildi",
  API_BULK_FETCH: "API üzerinden toplu veri çekildi",
  MENTORUM_RECORDS_EXPORTED: "Mentörüm kayıtlarının resmi başvuru kopyası üretildi",

  // --- SYSTEM — sistem ---------------------------------------------
  BACKUP_STARTED: "Yedekleme başladı",
  BACKUP_SUCCEEDED: "Yedekleme tamamlandı",
  BACKUP_FAILED: "Yedekleme başarısız oldu",
  BACKUP_VERIFIED: "Yedek geri yüklenerek doğrulandı",
  RESTORE_STARTED: "Yedekten geri yükleme başladı",
  RESTORE_COMPLETED: "Yedekten geri yükleme tamamlandı",
  MAINTENANCE_ON: "Bakım kipi açıldı",
  MAINTENANCE_OFF: "Bakım kipi kapatıldı",
  MIGRATION_APPLIED: "Veritabanı güncellemesi uygulandı",
  JOB_SUCCEEDED: "Zamanlanmış iş başarıyla bitti",
  JOB_FAILED: "Zamanlanmış iş hata verdi",
  INTEGRATION_ERROR: "Dış servis bağlantısı hata verdi",
  DEPLOYED: "Yeni sürüm yayına alındı",
  LOG_PURGED: "Süresi dolan log kayıtları temizlendi",
  RETENTION_PURGE: "Saklama süresi dolan kayıtlar temizlendi",
  PERSONAL_DATA_ANONYMIZED: "Saklama süresi dolan kişisel veri anonimleştirildi",
  SETTING_UPDATED: "Sistem ayarı değiştirildi",
  POINTS_WEEK_SETTLED: "Haftanın puanları kesinleşti",
  POINTS_EXPIRY_NOTIFIED: "Puan süresi dolmak üzere — öğrenciye bildirildi",
  POINTS_EXPIRED: "Kullanılmayan puanın süresi doldu",

  // --- SECURITY — guvenlik -----------------------------------------
  // G-IZL-03a — KENDI dokumunu acan icin yazilmiyor; cumle bu yuzden
  // "baskasinin" diyor, yoksa kayit yanlis okunurdu.
  ACTIVITY_DETAIL_OPENED: "Başkasının etkinlik dökümü açıldı",
  ALERT_TRIGGERED: "Uyarı kuralı eşiği aşıldı",
  BREACH_CHECK_UNAVAILABLE: "Sızmış şifre kontrolü çalıştırılamadı",
  ALERT_RULE_UPDATED: "Uyarı kuralı değiştirildi",
  RATE_LIMIT_HIT: "İstek hız sınırına takıldı",
  PASSWORD_RESET_UNKNOWN: "Olmayan hesap için şifre sıfırlama istendi",
  IDOR_ATTEMPT: "Başkasının kaydına erişim denendi",
  SUSPICIOUS_UPLOAD: "Şüpheli dosya yüklemesi reddedildi",
  TWO_FACTOR_BRUTE_FORCE: "İki adımlı doğrulama art arda yanlış girildi",
  PASSWORD_CHANGE_FAILED: "Şifre değiştirmede mevcut şifre yanlış girildi",
  PASSWORD_CHANGE_BRUTE_FORCE: "Şifre değiştirmede mevcut şifre art arda yanlış girildi",
  SUDO_BRUTE_FORCE: "Hassas işlem onayında şifre art arda yanlış girildi",
  TWO_FACTOR_CHECK_UNAVAILABLE: "İki adımlı doğrulama yapılamadı, giriş reddedildi",
  SUSPICIOUS_LOCATION: "Şüpheli bir konumdan giriş yapıldı",
  BULK_READ_ANOMALY: "Olağandışı sayıda kayıt okundu",
  OFF_HOURS_ACCESS: "Mesai dışı saatte erişim yapıldı",
  CSRF_BLOCKED: "Sahte site üzerinden gelen istek engellendi",
  // Hangi ayarın hangi yöne değiştiği `changes` alanında; bu metin
  // yalnızca listede ne olduğunu söylüyor.
  SECURITY_SETTING_CHANGED: "Güvenlik ayarı değiştirildi",
  CREDENTIAL_ROTATED: "Kimlik yerine geçen erişim jetonu yenilendi",
  // G-SES-01 — tek aciklamasi cerezin KOPYALANMIS olmasi. Cumle
  // "jeton eskimis" demiyor: kullanicinin butun oturumlari bu yuzden
  // kapaniyor ve satiri okuyan kisi sebebi anlamali.
  SESSION_TOKEN_REUSED: "Kopyalanmış olabilecek oturum jetonu görüldü",
  TRUSTED_DEVICE_ADDED: "Cihaz güvenilir olarak işaretlendi",
  TRUSTED_DEVICE_USED: "Güvenilir cihaz sayesinde kod sorulmadı",
  TRUSTED_DEVICE_REVOKED: "Cihazın güvenilir işareti kaldırıldı",

  /*
    ACİL DURUM İŞLEMLERİ — F-SEC-06.

    Metinler tekil karşılıklarından AYRI ve bilerek daha ağır:
    "Oturum uzaktan sonlandırıldı" bir müdahaledir, "Bütün oturumlar
    sonlandırıldı" bir olaydır. Denetim kaydını okuyan kişi ikisini
    satırın kendisinden ayırt edebilmeli — `affectedCount` sayısına
    bakarak değil.
  */
  /*
    F-MSG-06. Metin "okundu" diyor, "görüntülendi" demiyor: denetim
    kaydını okuyan kişi burada bir müdahale olduğunu anlamalı, sıradan
    bir listeleme değil.
  */
  CONVERSATION_READ: "Başkasının yazışması gerekçeyle okundu",
  MASS_SESSION_REVOKE: "Bütün oturumlar sonlandırıldı (acil durum)",
  MASS_TRUSTED_DEVICE_REVOKE: "Bütün güvenilir cihazlar iptal edildi (acil durum)",
  USER_FROZEN: "Kullanıcı donduruldu (hesap, oturumlar ve cihazlar)",
  // Cümle önce GİTTİĞİNİ söylüyor: bu bir arıza kaydı değil, bir
  // yapılandırma boşluğu kaydı. Satırı okuyan kişi "uyarı gitmedi"
  // sanıp gereksiz yere telaşlanmamalı — eksik olan şablon.
  SECURITY_NOTICE_TEMPLATE_MISSING: "Güvenlik uyarısı şablonsuz, gömme metinle gönderildi",
} satisfies Record<string, string>;

/**
 * Sozlukteki olay tipleri.
 *
 * Ayri bir birlesim olarak ELLE YAZILMIYOR, sozlukten turetiliyor:
 * yazilsaydi ayni ad iki yerde durur ve biri otekinden sessizce
 * ayrisabilirdi. Katalogla (`events.ts`) hizada kalmayi bekci test
 * olcuyor.
 */
export type OlayTipi = keyof typeof OLAY_METNI;

/*
  Ekran `satir.type`i duz `string` olarak aliyor (sunucudan JSON
  geliyor, daraltilmasi bir yalan olurdu). `Map` ile aramak, tipi
  zorla daraltip `as` yazmaktan daha durust.
*/
const SOZLUK: ReadonlyMap<string, string> = new Map(Object.entries(OLAY_METNI));

/**
 * Olay tipinin okunabilir Turkce karsiligi; TANIMSIZ tipte `null`.
 *
 * `null` doner, teknik kodu geri VERMEZ: cagiran taraf teknik kodu
 * zaten ayrica gosteriyor ve buradan da dondurseydik ekranda ayni
 * dizgi iki kez yazardi. Tanimsiz bir tipte satir en kotu ihtimalle
 * bugunku haline duser — bos bir alana degil.
 */
export function olayMetni(tip: string): string | null {
  return SOZLUK.get(tip) ?? null;
}

/** Bekci testin ve gelistirme araclarinin okudugu ham sozluk. */
export const OLAY_METNI_SOZLUGU: Readonly<Record<OlayTipi, string>> = OLAY_METNI;
